import { RegisterAccountSection } from 'modules';
import React from 'react';



export type RegisterActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const RegisterActivity = (props: RegisterActivityProps) => {

  return (
    <RegisterAccountSection.FC />
  );
};
